//@ts-check
import React, {
    Fragment,
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react';
import styled, { css } from 'styled-components';
import { updateUrlWithWeglotLang } from '../utils/weglotStorageHelper';
import LanguageSwitch from './shared/LanguageSwitch';
import usePageScroll from '../utils/usePageScroll';
import { concat } from '../utils/concat';
import { useLanguage } from '../utils/useLanguage';
import InstagramThin from '../base/icons/InstagramThin';
import FacebookThin from '../base/icons/FacebookThin';
import Pinterest from '../base/icons/Pinterest';
import LinkedIn from '../base/icons/LinkedIn';
import YoutubeThin from '../base/icons/YoutubeThin';

const NavView = styled.nav`
    ${(props) => {
        if (props.theme === 'employer') {
            return css`
                @media (min-width: 40em) {
                    color: #333333;

                    /* background-color: #5b594b !important; */
                }
            `;
        }

        if (props.theme === 'golf') {
            return css`
                @media (min-width: 40em) {
                    color: #333333;

                    /* background-color: #333333 !important; */
                }
            `;
        }
    }}
`;

/**
 * @param {{isOpen: boolean, items: {label: string, link: string, isBig: boolean, isActive: boolean, children: {label: string, link: string, image: string | undefined, isActive: boolean, hasTopSpace: boolean | undefined}[] | undefined}[], additionals: {link: string, label: string,hasTopSpace: boolean, isActive: boolean}[] | undefined, facebook: string | undefined, insta: string | undefined, youtube: string | undefined, pinterest: string | undefined, linkedin: string | undefined, onRequestClose: () => void, onItemClick: () => void, ignoreEmptyChildren: boolean | undefined, theme: 'employer' | undefined, bottomActions: {link: string | undefined, label: string | undefined; isExternal: boolean | undefined}[] | undefined, showLangSwitch: boolean | undefined; langs: {key: string, path: string | undefined}[] | undefined}} props
 */
const Nav = ({
    isOpen,
    items,
    additionals,
    facebook,
    insta,
    youtube,
    pinterest,
    linkedin,
    onRequestClose,
    onItemClick,
    ignoreEmptyChildren,
    theme,
    bottomActions,
    showLangSwitch,
    langs,
}) => {
    const isMobile = !matchMedia('(min-width:  40em)').matches;
    const itemsWithChildren = ignoreEmptyChildren
        ? items
        : items && items.filter(({ children }) => children.length > 0);
    const itemsWithoutChildren = ignoreEmptyChildren
        ? []
        : items && items.filter(({ children }) => children.length === 0);

    return (
        <React.Fragment>
            {isOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        backgroundColor: ' rgba(0,0,0,0.1)',
                    }}
                    onClick={onRequestClose}
                />
            )}

            <NavView
                className={`header__nav ${isOpen ? 'header__nav--open' : ''}`}
                id="js-nav"
                theme={theme}
            >
                <ul className="header__nav__first">
                    {itemsWithChildren &&
                        itemsWithChildren.map(
                            (
                                { label, link, children, isBig, isActive },
                                index
                            ) => {
                                return (
                                    <li key={index}>
                                        <a
                                            href={link}
                                            className={
                                                isActive
                                                    ? 'is-active'
                                                    : undefined
                                            }
                                            onClick={onItemClick}
                                        >
                                            {label}{' '}
                                            {!ignoreEmptyChildren && (
                                                <span>zur Übersicht</span>
                                            )}
                                        </a>
                                        {!ignoreEmptyChildren && (
                                            <ul
                                                data-list-index={index}
                                                className={`header__nav__second ${
                                                    !isBig
                                                        ? 'header__nav__second--small'
                                                        : ''
                                                }`}
                                            >
                                                {children.map(
                                                    (
                                                        {
                                                            link,
                                                            label,
                                                            image,
                                                            isActive,
                                                            hasTopSpace,
                                                        },
                                                        index
                                                    ) => {
                                                        return (
                                                            <li
                                                                key={index}
                                                                className={
                                                                    hasTopSpace
                                                                        ? 'header__nav__topspace'
                                                                        : undefined
                                                                }
                                                            >
                                                                <a
                                                                    href={link}
                                                                    className={
                                                                        isActive
                                                                            ? 'is-active'
                                                                            : undefined
                                                                    }
                                                                    onClick={
                                                                        onItemClick
                                                                    }
                                                                >
                                                                    {image ? (
                                                                        <img
                                                                            src={
                                                                                image
                                                                            }
                                                                            alt={
                                                                                label
                                                                            }
                                                                            loading="lazy"
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src="//placehold.it/235?text=%20"
                                                                            alt={
                                                                                label
                                                                            }
                                                                            loading="lazy"
                                                                        />
                                                                    )}

                                                                    <span
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: label,
                                                                        }}
                                                                    />
                                                                </a>
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        )}
                                    </li>
                                );
                            }
                        )}
                    {itemsWithoutChildren &&
                        itemsWithoutChildren.length > 0 && (
                            <li className="header__nav__group">
                                {itemsWithoutChildren.map(
                                    ({ link, label, isActive }) => {
                                        return (
                                            <a
                                                key={label}
                                                href={link}
                                                className={
                                                    isActive
                                                        ? 'is-active'
                                                        : undefined
                                                }
                                                onClick={onItemClick}
                                            >
                                                {label}
                                            </a>
                                        );
                                    }
                                )}
                            </li>
                        )}

                    {additionals && (
                        <React.Fragment>
                            <li className="header__nav__spacer"></li>
                            <li className="header__nav__group  header__nav__group--small">
                                {additionals.map(
                                    (
                                        { link, label, hasTopSpace, isActive },
                                        index
                                    ) => {
                                        const classNames = [];
                                        if (hasTopSpace)
                                            classNames.push('has-topspace');
                                        if (isActive)
                                            classNames.push('is-active');

                                        return (
                                            <a
                                                key={index}
                                                className={
                                                    classNames.length > 0
                                                        ? classNames.join(' ')
                                                        : undefined
                                                }
                                                href={link}
                                                onClick={onItemClick}
                                            >
                                                {label}
                                            </a>
                                        );
                                    }
                                )}
                            </li>
                        </React.Fragment>
                    )}
                </ul>

                <ul
                    className="header__nav__first  header__nav__first--nospace"
                    style={{ marginBottom: 10 }}
                >
                    <li className="header__nav__spacer"></li>
                    <li className="header__nav__group  header__nav__group--small header__nav__group--full header__nav__group--actions">
                        <div className="nav__actions nav__actions--full">
                            {Array.isArray(bottomActions) &&
                                bottomActions.map((item, i) => (
                                    <a
                                        key={i}
                                        href={item.link}
                                        className={`btn--ghost${
                                            !isMobile ? '--invert' : ''
                                        }`}
                                        target={
                                            item.isExternal
                                                ? '_blank'
                                                : undefined
                                        }
                                    >
                                        {item.label}
                                    </a>
                                ))}
                        </div>

                        <span
                            style={{
                                color: !isMobile && '#fff',
                                marginLeft: '0px',
                            }}
                        >
                            {showLangSwitch && (
                                <LanguageSwitch
                                    langs={
                                        Array.isArray(langs)
                                            ? langs
                                            : [{ key: 'de' }, { key: 'en' }]
                                    }
                                />
                            )}
                        </span>
                        <span
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                            }}
                        >
                            {facebook && (
                                <a href={facebook} target="_blank">
                                    <FacebookThin className="header__sm-icon" />
                                </a>
                            )}

                            {insta && (
                                <a href={insta} target="_blank">
                                    <InstagramThin className="header__sm-icon" />
                                </a>
                            )}

                            {pinterest && (
                                <a href={pinterest} target="_blank">
                                    <Pinterest className="header__sm-icon" />
                                </a>
                            )}

                            {linkedin && (
                                <a href={linkedin} target="_blank">
                                    <LinkedIn className="header__sm-icon" />
                                </a>
                            )}

                            {youtube && (
                                <a href={youtube} target="_blank">
                                    <YoutubeThin className="header__sm-icon" />
                                </a>
                            )}
                        </span>
                    </li>
                </ul>
            </NavView>
        </React.Fragment>
    );
};

// const QuickNavView = styled.ul`
//     margin: 0;
//     padding: 0;
//     position: fixed;
//     right: 0;
//     top: 0;
//     z-index: 2;
//     list-style: none;
//     font-weight: 700;
//     text-transform: uppercase;
//     overflow: hidden;
//     will-change: transform;
//     /* transition: transform 0.1s; */
// `;

// const QuickNavItem = styled.li`
//     margin: 5px 0;
//     background-color: #fff;
//     text-align: right;
//     transform: ${(props) =>
//         props.open ? 'none' : 'translateX(calc(100% - 62px))'};
//     transition: transform 0.5s cubic-bezier(0.6, 0, 0.38, 1);

//     @media (hover: hover) and (pointer: fine) {
//         &:hover {
//             transform: none;
//         }
//     }

//     a {
//         display: flex;
//         align-items: center;
//         color: currentColor;
//         text-decoration: none;
//         padding: 10px;
//     }

//     svg {
//         fill: currentColor;
//     }
// `;

// const QuickNavItemIcon = styled.span`
//     width: 43px;
//     text-align: center;
// `;

// const QuickNavItemLabel = styled.span`
//     padding-left: 20px;
//     padding-right: 20px;
// `;

// /**
//  *
//  * @typedef QuickNavItem
//  * @type {object}
//  * @property {string} icon
//  * @property {string} label
//  * @property {string} link
//  * @property {string} target
//  */

// /**
//  *
//  * @param {{items: QuickNavItem[], fullscreen: boolean, hideOnMobile: boolean}} props
//  */
// const QuickNav = ({ items, fullscreen, hideOnMobile }) => {
//     const [translate, setTranslate] = useState(0);
//     const ref = useRef();
//     const [activeIndex, setActiveIndex] = useState();
//     const isMobile = !matchMedia('(min-width:  64em)').matches;

//     const performTranslation = useCallback(() => {
//         const { top } = document.body.getBoundingClientRect();
//         setTranslate(top);
//         setActiveIndex(undefined);
//     }, []);

//     // const handleBodyClick = useCallback(() => {
//     //     setActiveIndex(undefined);
//     // }, []);

//     useEffect(() => {
//         window.addEventListener('scroll', performTranslation);
//         // document.body.addEventListener('touchstart', handleBodyClick);
//         return () => {
//             window.removeEventListener('scroll', performTranslation);
//             // document.body.removeEventListener('touchstart', handleBodyClick);
//         };
//     }, []);

//     if (hideOnMobile && isMobile) return null;

//     return (
//         <QuickNavView
//             ref={ref}
//             className="h-fg--contrast--dark"
//             style={{
//                 transform: `translateY(calc(${
//                     fullscreen && !isMobile ? '47vh' : '25vh'
//                 } + ${translate}px))`,
//             }}
//         >
//             {items.map((item, index) => {
//                 return (
//                     <QuickNavItem key={item.label} open={activeIndex === index}>
//                         <a
//                             href={item.link}
//                             target={item.target}
//                             onClick={(e) => {
//                                 if (!matchMedia('(min-width:64em)').matches) {
//                                     e.preventDefault();

//                                     if (activeIndex === index) {
//                                         e.stopPropagation();
//                                         window.location.href = item.link;
//                                     } else {
//                                         setActiveIndex(index);
//                                     }
//                                 }
//                             }}
//                             // onFocus={() => {
//                             //     if (!matchMedia('(min-width:64em)').matches) {
//                             //         setTimeout(() => {
//                             //             setActiveIndex(index);
//                             //         }, 100);
//                             //     }
//                             // }}
//                             onBlur={() => setActiveIndex(undefined)}
//                             // onTouchStart={() => {
//                             //     if (!matchMedia('(min-width:64em)').matches) {
//                             //         setTimeout(() => {
//                             //             setActiveIndex(index);
//                             //         }, 100);
//                             //     }
//                             // }}
//                         >
//                             <QuickNavItemIcon
//                                 dangerouslySetInnerHTML={{ __html: item.icon }}
//                             />
//                             <QuickNavItemLabel>{item.label}</QuickNavItemLabel>
//                         </a>
//                     </QuickNavItem>
//                 );
//             })}
//         </QuickNavView>
//     );
// };

const HeaderActions = styled.span`
    flex-wrap: wrap;

    @media (min-width: 64em) {
        flex-wrap: nowrap;
    }
`;

const FloatingButtons = styled.span`
    width: 100%;
    /* display: ${({ hide }) => (hide ? 'none' : 'flex')}; */
    opacity: ${({ hide }) => (hide ? 0 : 1)};
    pointer-events: ${({ hide }) => (hide ? 'none' : 'all')};
    display: flex;

    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;

    transition: opacity 0.3s ease-in-out;

    .header__action--ghost {
        color: #fff;
    }

    ${({ show, hideOnMobile }) => {
        if (hideOnMobile && show) {
            return css`
                display: none;
            `;
        }

        if (!show) {
            return css`
                width: auto;
                margin-top: 5px;
                margin-left: 20px;
                position: static;
                transform: none;
                display: flex;

                .header__action--ghost {
                    color: inherit;
                }

                a {
                    margin-right: 5px !important;
                }
            `;
        }
    }}

    & > * {
        flex: 1;
    }

    @media (min-width: 64em) {
        display: none;
    }
`;

const ActionsBlock = styled.span`
    display: ${({ isFlyoutOpen }) => (isFlyoutOpen ? 'flex' : 'none')};
    width: auto;
    z-index: 10;

    margin-top: 0;
    position: static;
    transform: none;

    a {
        margin-right: 0 !important;
    }

    .header__action--ghost {
        color: inherit;
    }

    & > * {
        flex: 1;
    }

    & > * + * {
        margin-left: 5px;
    }

    @media (min-width: 64em) {
        display: flex;
    }
`;

const HeaderAction = styled.a`
    ${(props) => {
        if (props.theme === 'golf' && props.isPrimary) {
            return css`
                && {
                    /* border: 1px solid #53976f !important; */
                    background-color: #5e662d;
                    border-color: #5e662d;

                    @media (hover: hover) and (pointer: fine) {
                        &:hover:not(:disabled) {
                            background-color: #3d431d;
                            border-color: #3d431d;
                        }
                    }

                    &:focus {
                        background-color: #3d431d;
                        border-color: #3d431d;
                    }
                }
            `;
        }
    }}
`;

const Tooltip = styled.a`
    text-decoration: none;
    text-align: center;
    margin-top: ${(props) => (props.showLabel ? '0' : '0')};

    @media (min-width: 64em) {
        margin-top: ${(props) => (props.showLabel ? '0' : '0')};
        text-align: left;

        &:hover {
            .header__tooltips__item__hover {
                display: block;
                opacity: ${(props) => (props.showLabel ? 1 : 0)};
            }
        }
    }

    .header__tooltips__item__hover {
        display: block;
        opacity: 0;
        margin-left: 0;
        width: 100%;
        /* position: static; */
        /* transform: none; */
        padding-bottom: 10px;

        &::before {
            display: none;
        }

        @media (min-width: 64em) {
            color: inherit;
            width: 150px;
            position: absolute;
            opacity: ${(props) => (props.showLabel ? 1 : 0)};
            /* display: none; */
            opacity: 0;
            padding-bottom: 40px;

            &::before {
                display: block;
            }
        }
    }

    /* .header__tooltips__item__icon {
        display: ${(props) => (props.showLabel ? 'none' : 'block')};

        @media (min-width: 64em) {
            display: block;
        }
    } */
`;

const View = styled.div`
    .header__nav__first {
        padding-top: 170px;
    }

    .header__nav__first:last-child {
        padding-top: 40px;

        @media (min-width: 40em) {
            padding-top: 170px;
        }
    }

    .header__burger {
        flex: ${(props) => (props.flyoutOpen ? 'none' : 1)};

        @media (min-width: 40em) {
            flex: 1;
        }
    }

    ${(props) => {
        if (props.theme === 'golf') {
            return css`
                @media (min-width: 40em) {
                    &.header--nav .header__top {
                        background-color: #333333 !important;
                    }

                    .header__burger__icons:hover {
                        color: #cfcfcf !important;
                    }

                    @media (hover: hover) and (pointer: fine) {
                        .header__toggle--inverted:hover {
                            color: #cbc9c4 !important;
                        }
                    }
                }

                .header__nav__first
                    a:not(.btn--ghost):not(.btn--ghost--invert) {
                    &:hover,
                    &.is-active {
                        color: #9fb89f !important;

                        span {
                            color: #9fb89f !important;
                        }
                    }
                }
            `;
        }

        if (props.theme === 'employer') {
            return css`
                @media (min-width: 40em) {
                    &.header--nav .header__top {
                        background-color: #333333 !important;
                    }

                    @media (hover: hover) and (pointer: fine) {
                        .header__toggle--inverted:hover {
                            color: #cbc9c4 !important;
                        }
                    }
                }

                .header__nav__first {
                    display: block;
                    text-align: center;
                }

                .header__nav__first
                    a:not(.btn--ghost):not(.btn--ghost--invert) {
                    padding-top: 20px !important;
                    padding-bottom: 20px !important;
                    display: inline-block !important;
                    font-family: 'Lato', sans-serif !important;
                    font-weight: 600 !important;
                    text-transform: uppercase !important;
                    font-size: 20px !important;
                    letter-spacing: 3px;

                    &:hover:not(:disabled),
                    &.is-active {
                        color: #be9d35 !important;

                        span {
                            color: #be9d35 !important;
                        }
                    }
                }

                .header__nav__first > li {
                    padding-right: 0 !important;
                }

                .header__action--primary {
                    background-color: #be9d35 !important;
                    border-color: #be9d35 !important;

                    @media (hover: hover) and (pointer: fine) {
                        &:focus,
                        &:hover:not(:disabled) {
                            background-color: #ab8d2f !important;
                            border-color: #ab8d2f !important;
                        }
                    }
                }
            `;
        }
    }}
`;

/**
 * @param {{de: {logo: string | undefined, showLargeLogo: boolean | undefined, tooltips: {closed:{link: string | undefined, icon: string, tooltip: string | undefined}[], open:{link: string | undefined, icon: string,tooltip: string | undefined}[],closedMobile:{link: string | undefined, icon: string, tooltip: string | undefined}[],openMobile:{link: string | undefined, icon: string, tooltip: string | undefined}[]} | undefined, actions: {link: string | undefined, label: string, labelEn: string | undefined, primary: boolean | undefined, newTab: boolean | undefined, width: number | undefined}[] | undefined, isInverted: boolean | undefined, scrollOffset: number | undefined, items: {label: string, link: string, isBig: boolean, isActive: boolean, children: {label: string, link: string, image: string, isActive: boolean, hasTopSpace: boolean | undefined}[] | undefined}[] | undefined, additionals: {link: string, label: string, hasTopSpace: boolean}[] | undefined, facebook: string | undefined, insta: string | undefined, youtube: string | undefined, pinterest: string | undefined, linkedin: string | undefined, homelink: string | undefined, breadcrumbs: {link: string | label: string}[] | undefined, ignoreEmptyChildren: boolean | undefined, preventInvertOnMobile: boolean | undefined, hideFloatingButtonsOnMobile: boolean | undefined, theme: 'employer' | 'golf' | undefined, bottomActions: {link: string | undefined, label: string | undefined, isExternal: boolean | undefined}[] | undefined, quickNav: QuickNavItem[] | undefined, fullscreen: boolean | undefined, actionInnerHtml: string | undefined, showLangSwitch: boolean | undefined}}}
 */
const HeaderApp = (props) => {
    const data = {
        de: props.de || {},
        en: props.en || {},
    };
    const { lang } = useLanguage();

    const {
        logo,
        showLargeLogo,
        tooltips,
        actions,
        isInverted,
        scrollOffset = 0,
        items,
        additionals,
        facebook,
        insta,
        youtube,
        pinterest,
        linkedin,
        homelink = '/',
        breadcrumbs,
        ignoreEmptyChildren,
        preventInvertOnMobile,
        hideFloatingButtonsOnMobile,
        theme,
        bottomActions,
        // quickNav,
        // fullscreen,
        actionInnerHtml,
        showLangSwitch,
        langs,
    } = data[lang || 'de'] || {};

    const [flyoutOpen, setFlyoutOpen] = useState(false);
    const [currentTooltip, setCurrentTooltip] = useState();
    // const [isMobile, setMobile] = useState(true);
    const [classNames, setClassNames] = useState(['header header--open']);
    const [isMenuInverted, setIsMenuInverted] = useState(false);

    const [isNavBarSticky, setIsNavBarSticky] = useState(false);
    const [isNavBarOpen, setNavBarOpen] = useState(true);
    const { isTop, scrollDirection, isInOffset, leftOffsetFromTop } =
        usePageScroll({
            directionOffset: { up: 40, down: 40 },
            offset: scrollOffset || 0,
        });

    useEffect(() => {
        setNavBarOpen(isTop || isInOffset || scrollDirection === 'UP');
    }, [scrollDirection, isTop, isInOffset]);

    useEffect(() => {
        if (leftOffsetFromTop && scrollDirection === 'UP') {
            setIsNavBarSticky(true);
        } else if (isTop) {
            setIsNavBarSticky(false);
        }
    }, [isTop, leftOffsetFromTop, scrollDirection]);

    const updateMenuInvertState = () => {
        const isMobile = !matchMedia('(min-width:  40em)').matches;

        if (flyoutOpen) {
            setIsMenuInverted(!isMobile);
            return;
        }
        setIsMenuInverted(!isInverted ? false : !isNavBarSticky);
    };

    useEffect(() => {
        updateMenuInvertState();
    }, [isNavBarSticky]);

    useEffect(() => {
        window.postMessage(
            JSON.stringify({
                type: 'sona-header-message',
                data: JSON.stringify({
                    isNavBarSticky,
                    isNavBarOpen,
                    flyoutOpen,
                    isMenuInverted,
                    isTop,
                    scrollDirection,
                    isInOffset,
                    leftOffsetFromTop,
                }),
            })
        );
    }, [
        isNavBarSticky,
        isNavBarOpen,
        flyoutOpen,
        isMenuInverted,
        isTop,
        scrollDirection,
        isInOffset,
        leftOffsetFromTop,
    ]);

    const invertTimerRef = useRef(null);
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (invertTimerRef.current !== undefined) {
            window.clearTimeout(invertTimerRef.current);
        }

        window.setTimeout(updateMenuInvertState, flyoutOpen ? 0 : 700);
    }, [flyoutOpen]);

    const setTooltips = useCallback(() => {
        if (tooltips) {
            if (matchMedia('(min-width:  64em)').matches) {
                if (flyoutOpen) {
                    setCurrentTooltip(tooltips.open);
                } else {
                    setCurrentTooltip(tooltips.closed);
                }
                // setMobile(false);
            } else {
                if (flyoutOpen) {
                    setCurrentTooltip(tooltips.openMobile);
                } else {
                    setCurrentTooltip(tooltips.closedMobile);
                }
                // setMobile(true);
            }
        }
    }, [flyoutOpen, tooltips]);

    const calcClassNames = useCallback(() => {
        const isMobile = !matchMedia('(min-width:  64em)').matches;
        const cNames = ['header'];

        if (isInverted) {
            if (isMobile) {
                if (!preventInvertOnMobile) {
                    cNames.push('header--inverted');
                }
            } else {
                cNames.push('header--inverted');
            }
        }

        if (flyoutOpen) {
            cNames.push('header--nav');
            cNames.push('header--nav--open');
        }

        if (isNavBarSticky) {
            cNames.push('header--sticky');
        }

        if (isNavBarOpen) {
            cNames.push('header--open');
        }

        setClassNames(cNames);
    }, [
        flyoutOpen,
        isNavBarSticky,
        isNavBarOpen,
        preventInvertOnMobile,
        isInverted,
    ]);

    useEffect(() => {
        // set initial sticky position
        // setIsSticky(window.scrollY >= scrollOffset);

        document.querySelector('body').classList.add('fl');
        // document.addEventListener('scroll', handleScroll);
        // document.addEventListener('wheel', handleWheelScroll);
        // document.addEventListener('touchmove', handleTouchMove);

        return () => {
            // document.removeEventListener('scroll', handleScroll);
            // document.removeEventListener('wheel', handleWheelScroll);
            // document.removeEventListener('touchmove', handleTouchMove);
        };
    }, []);

    useEffect(() => {
        window.addEventListener('resize', setTooltips);
        window.addEventListener('resize', calcClassNames);
        window.addEventListener('resize', updateMenuInvertState);

        return () => {
            window.removeEventListener('resize', setTooltips);
            window.removeEventListener('resize', calcClassNames);
            window.removeEventListener('resize', updateMenuInvertState);
        };
    }, [setTooltips, calcClassNames, updateMenuInvertState]);

    useEffect(() => {
        setTooltips();
        calcClassNames();
    }, [setTooltips, calcClassNames]);

    const handleItemClick = useCallback((ev) => {
        const { currentTarget } = ev;
        const nav = document.getElementById('js-nav');
        const list = currentTarget.parentNode.parentNode;

        if (list) {
            sessionStorage.setItem(
                'sonaScrollX',
                JSON.stringify({
                    index: list.getAttribute('data-list-index'),
                    pos: list.scrollLeft,
                })
            );
        }

        if (nav && 'sessionStorage' in window) {
            sessionStorage.setItem('sonaScrollY', nav.scrollTop);
        }

        const linkUrl = new URL(currentTarget.href, window.location.href);
        const currentUrl = new URL(window.location.href);

        if (
            linkUrl.origin === currentUrl.origin &&
            linkUrl.pathname.replace(/\/+$/, '') ===
                currentUrl.pathname.replace(/\/+$/, '')
        ) {
            setFlyoutOpen(false);
        }
    }, []);

    useEffect(() => {
        let list;

        const scrollXData = JSON.parse(
            sessionStorage.getItem('sonaScrollX') || '{}'
        );

        const nav = document.getElementById('js-nav');

        if (scrollXData) {
            list = document.querySelector(
                `[data-list-index="${scrollXData.index}"]`
            );
        }

        if (nav && 'sessionStorage' in window) {
            const scrollY = sessionStorage.getItem('sonaScrollY');

            setTimeout(() => {
                nav.scrollTop = parseInt(scrollY, 10);

                if (list && scrollXData) {
                    list.scrollLeft = scrollXData.pos;
                }
            }, 300);
        }
    }, []);

    useEffect(() => {
        document.body.style.overflow = flyoutOpen ? 'hidden' : 'visible';
    }, [flyoutOpen]);

    return (
        <Fragment>
            <View
                className={classNames.join(' ')}
                theme={theme}
                flyoutOpen={flyoutOpen}
            >
                <div className="header__top">
                    <div className="header__col  header__toggle__wrapper">
                        <button
                            aria-label="menu"
                            className={`header__toggle ${
                                flyoutOpen ? 'header__toggle--close' : ''
                            }`}
                            onClick={() => setFlyoutOpen((prev) => !prev)}
                        >
                            <span />
                            <span />
                            <span />
                            <span
                                aria-hidden="true"
                                style={{
                                    display: flyoutOpen ? 'none' : 'block',
                                }}
                            >
                                <svg
                                    width="34"
                                    height="11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.36 2.119V10h-.935V4.209c0-.077.002-.16.006-.248l.022-.27L4.747 8.62c-.085.165-.213.247-.385.247h-.154c-.173 0-.301-.082-.385-.247L1.062 3.67c.022.194.033.374.033.539V10H.16V2.119h.786c.096 0 .169.009.22.027.052.018.101.07.149.154l2.722 4.851c.044.088.086.18.127.275.044.095.084.193.12.292.037-.1.076-.197.116-.292a2.83 2.83 0 0 1 .132-.28L7.205 2.3c.044-.084.092-.136.143-.154a.738.738 0 0 1 .226-.027h.786ZM16.117 9.131l-.005.869h-4.856V2.119h4.856v.869h-3.79v2.618h3.07v.836h-3.07V9.13h3.796ZM24.87 2.119V10h-.534a.476.476 0 0 1-.214-.044.549.549 0 0 1-.165-.148l-4.56-5.94a6.81 6.81 0 0 1 .022.517V10h-.935V2.119h.55a.568.568 0 0 1 .21.038.25.25 0 0 1 .076.055.652.652 0 0 1 .083.088l4.56 5.935a37.064 37.064 0 0 0-.023-.275 6.616 6.616 0 0 1-.005-.259V2.119h.935ZM30.806 9.153c.326 0 .618-.055.874-.165.257-.11.474-.264.65-.462.18-.198.315-.434.407-.71.095-.274.142-.577.142-.907v-4.79h1.062v4.79c0 .455-.073.876-.22 1.265-.143.389-.35.726-.621 1.012a2.832 2.832 0 0 1-.985.666 3.386 3.386 0 0 1-1.309.242c-.484 0-.92-.081-1.309-.242a2.89 2.89 0 0 1-.99-.666 2.982 2.982 0 0 1-.627-1.012 3.636 3.636 0 0 1-.214-1.265v-4.79h1.061v4.785c0 .33.046.632.137.907.096.275.232.512.407.71.18.198.398.353.655.467.26.11.554.165.88.165ZM30.262.837a.557.557 0 0 1-.188.418.624.624 0 0 1-.198.132.616.616 0 0 1-.456 0 .665.665 0 0 1-.319-.319.57.57 0 0 1 0-.468.624.624 0 0 1 .319-.33.544.544 0 0 1 .456 0 .624.624 0 0 1 .336.33.57.57 0 0 1 .05.237Zm2.298 0c0 .08-.016.158-.049.231a.666.666 0 0 1-.325.319.63.63 0 0 1-.468 0 .643.643 0 0 1-.323-.319.632.632 0 0 1 0-.468.624.624 0 0 1 .324-.33.57.57 0 0 1 .468 0 .624.624 0 0 1 .374.566Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </span>
                        </button>

                        {!flyoutOpen &&
                            !isNavBarSticky &&
                            isNavBarOpen &&
                            breadcrumbs &&
                            breadcrumbs.length > 0 && (
                                <ul className="breadcrumb  header__breadcrumb">
                                    <li>
                                        <a href={homelink}>
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="icon"
                                            >
                                                <path
                                                    d="M10.794 20.066a.83.83 0 0 1-.83.83H4.986a.83.83 0 0 1-.83-.83v-7.202H2c-.759 0-1.12-.934-.558-1.444l9.955-9.034a.83.83 0 0 1 1.116 0l9.955 9.034c.561.51.2 1.444-.558 1.444h-2.157v7.202a.83.83 0 0 1-.83.83h-4.977a.83.83 0 0 1-.83-.83v-5.194h-2.322v5.194zm-1.66-6.023a.83.83 0 0 1 .83-.83h3.982a.83.83 0 0 1 .83.83v5.193h3.318v-7.201a.83.83 0 0 1 .83-.83h.838L11.955 4.12l-7.807 7.085h.838a.83.83 0 0 1 .83.83v7.201h3.318v-5.193z"
                                                    fillRule="nonzero"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                        </a>
                                    </li>

                                    {!flyoutOpen &&
                                        breadcrumbs.map(
                                            ({ link, label }, index) => (
                                                <li key={index}>
                                                    <a href={link}>{label}</a>
                                                </li>
                                            )
                                        )}
                                </ul>
                            )}
                    </div>
                    <span
                        className={concat(
                            [
                                'header__col',
                                'header__logo',
                                showLargeLogo && 'header__logo--large',
                            ],
                            ' '
                        )}
                    >
                        {logo && (
                            <a
                                href={homelink}
                                dangerouslySetInnerHTML={{ __html: logo }}
                            />
                        )}
                    </span>
                    <HeaderActions
                        className={concat(
                            [
                                'header__col  header__actions',
                                flyoutOpen && 'header__actions--compact',
                                isMenuInverted && 'header__actions--inverted',
                            ],
                            ' '
                        )}
                    >
                        {currentTooltip && (
                            <div className="header__tooltips">
                                {currentTooltip.map((tooltip, index) => (
                                    <Tooltip
                                        key={index}
                                        href={tooltip.link}
                                        className="header__tooltips__item"
                                        showLabel={!flyoutOpen}
                                    >
                                        {tooltip.tooltip && (
                                            <span className="header__tooltips__item__hover">
                                                {tooltip.tooltip}
                                            </span>
                                        )}
                                        <span
                                            className="header__tooltips__item__icon"
                                            dangerouslySetInnerHTML={{
                                                __html: tooltip.icon,
                                            }}
                                        />
                                    </Tooltip>
                                ))}
                            </div>
                        )}

                        <ActionsBlock isFlyoutOpen={flyoutOpen}>
                            {actionInnerHtml && (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: actionInnerHtml,
                                    }}
                                />
                            )}
                            <div style={{ display: 'none' }}>{lang}</div>
                            {actions &&
                                actions.length > 0 &&
                                actions.map(
                                    ({
                                        label,
                                        link,
                                        primary,
                                        newTab,
                                        labelEn,
                                        width,
                                    }) => {
                                        return (
                                            <HeaderAction
                                                key={label}
                                                isPrimary={primary}
                                                isInverted={isMenuInverted}
                                                href={updateUrlWithWeglotLang(
                                                    link,
                                                    lang
                                                )}
                                                style={
                                                    width
                                                        ? { width }
                                                        : undefined
                                                }
                                                target={
                                                    newTab
                                                        ? '_blank'
                                                        : undefined
                                                }
                                                className={`${
                                                    primary
                                                        ? 'header__action--primary'
                                                        : isMenuInverted
                                                          ? 'header__action--secondary-light'
                                                          : 'header__action--secondary-dark'
                                                } ${
                                                    labelEn ? 'notranslate' : ''
                                                }`}
                                                data-translate-toggle-text={
                                                    labelEn
                                                }
                                                theme={theme}
                                            >
                                                <span>{label}</span>
                                            </HeaderAction>
                                        );
                                    }
                                )}
                        </ActionsBlock>
                    </HeaderActions>
                </div>

                <Nav
                    isOpen={flyoutOpen}
                    items={items}
                    additionals={additionals}
                    facebook={facebook}
                    insta={insta}
                    youtube={youtube}
                    pinterest={pinterest}
                    linkedin={linkedin}
                    onRequestClose={() => setFlyoutOpen(false)}
                    onItemClick={handleItemClick}
                    ignoreEmptyChildren={ignoreEmptyChildren}
                    theme={theme}
                    bottomActions={bottomActions}
                    showLangSwitch={showLangSwitch}
                    langs={langs}
                />
            </View>

            {/* {quickNav && isInverted && (
                <QuickNav
                    items={quickNav}
                    fullscreen={fullscreen || false}
                    hideOnMobile={preventInvertOnMobile}
                />
            )} */}

            <FloatingButtons
                show={!flyoutOpen}
                hide={!isNavBarOpen}
                hideOnMobile={hideFloatingButtonsOnMobile}
            >
                {actionInnerHtml && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: actionInnerHtml,
                        }}
                    />
                )}
                <div style={{ display: 'none' }}>{lang}</div>
                {actions &&
                    actions.length > 0 &&
                    actions.map(
                        ({ label, link, primary, newTab, labelEn, width }) => {
                            return (
                                <HeaderAction
                                    key={label}
                                    isPrimary={primary}
                                    href={updateUrlWithWeglotLang(link, lang)}
                                    style={width ? { width } : undefined}
                                    target={newTab ? '_blank' : undefined}
                                    className={`${
                                        primary
                                            ? 'header__action--primary'
                                            : 'btn--invert'
                                    } ${labelEn ? 'notranslate' : ''}`}
                                    data-translate-toggle-text={labelEn}
                                    theme={theme}
                                >
                                    <span>{label}</span>
                                </HeaderAction>
                            );
                        }
                    )}
            </FloatingButtons>
        </Fragment>
    );
};

export default HeaderApp;



// WEBPACK FOOTER //
// ./src/components/Header.jsx